import React from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "../../lib/utils";

// A single labelled field wrapper.
// - Renders a descriptive label with a red * for required / muted (optional) tag.
// - Shows an inline error message (or a hint) beneath the control.
// Pass the input/select/textarea as children.
export function FormField({
  label,
  htmlFor,
  required = false,
  optional = false,
  hint,
  error,
  className,
  labelClassName,
  children,
}) {
  const errorId = (htmlFor || (typeof label === "string" ? label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") : undefined));
  const errorTestId = errorId ? `${errorId}-error` : undefined;
  return (
    <div className={cn("space-y-1", className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className={cn("block text-[11.5px] font-medium text-slate-600", labelClassName)}
        >
          {label}
          {required && <span className="text-rose-500 ml-0.5" aria-hidden="true">*</span>}
          {optional && <span className="text-slate-400 font-normal ml-1">(optional)</span>}
        </label>
      )}
      {children}
      {error ? (
        <p id={errorTestId} data-testid={errorTestId} className="flex items-center gap-1 text-[11px] text-rose-500">
          <AlertCircle className="w-3 h-3 shrink-0" />
          {error}
        </p>
      ) : hint ? (
        <p className="text-[11px] text-slate-400">{hint}</p>
      ) : null}
    </div>
  );
}

// Utility: append to an input className when the field has an error, to show a red ring.
export const errorRing = (error) =>
  error ? "border-rose-400 focus:border-rose-400 focus:ring-rose-200" : "";
